module.exports = __webpack_public_path__ + "gexinghua.467ef98c.png";